export default "__VITE_ASSET__50745211__"